/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TreeInputs */

const en_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plants`)
};

const ar_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نباتات`)
};

const de_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflanzen`)
};

const es_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantas`)
};

const fr_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantes`)
};

const it_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piante`)
};

const ja_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植物`)
};

const ko_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`식물`)
};

const pt_br_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantas`)
};

const ru_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Растения`)
};

const th_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้`)
};

const tr_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitkiler`)
};

const zh_cn_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植物`)
};

const zh_tw_tree = /** @type {(inputs: TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植物`)
};

/**
* | output |
* | --- |
* | "Plants" |
*
* @param {TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree = /** @type {((inputs?: TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree(inputs)
	if (locale === "ar") return ar_tree(inputs)
	if (locale === "de") return de_tree(inputs)
	if (locale === "es") return es_tree(inputs)
	if (locale === "fr") return fr_tree(inputs)
	if (locale === "it") return it_tree(inputs)
	if (locale === "ja") return ja_tree(inputs)
	if (locale === "ko") return ko_tree(inputs)
	if (locale === "pt_br") return pt_br_tree(inputs)
	if (locale === "ru") return ru_tree(inputs)
	if (locale === "th") return th_tree(inputs)
	if (locale === "tr") return tr_tree(inputs)
	if (locale === "zh_cn") return zh_cn_tree(inputs)
	return zh_tw_tree(inputs)
});